/**
 * @param {String} src - 脚本url
 * @return {Promise}
 */
export default function dynamicallyLoadScript (src) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.onload = resolve
    document.body.appendChild(script)
  })
}
